import React, { useEffect } from "react";
import JsBarcode from "jsbarcode";

import { DATE_FNS_SHORT_DATE_FORMAT } from "../../shared/constants";
import { format } from "date-fns";

const BinLabel = (props) => {
    useEffect(() => {
        JsBarcode(".barcode").init();
    }, []);

    const { binId, client, due, dueDates, destination, isPerishable, received, rush, supplier, trackingNumbers, upcCount } = { ...props.label };
    const index = props.index;
    const total = props.total;
    const rushText = rush ? "*RUSH*" : "";
    const measureingDue = dueDates.find((d) => d.tags.includes("Measuring"));
    const photoDue = dueDates.find((d) => d.tags.includes("Photography"));

    return (
        <div className="bin-label">
            <div className="label-row">
                <div className="label-column -span8">
                    <h1>{binId}</h1>
                </div>
                <div className="label-column -span4 txt-right">
                    <h1>{rushText}</h1>
                </div>
            </div>
            <div className="label-row">
                <div className="label-column -span5">
                    <div className="barcode-container">
                        <svg
                            className="barcode"
                            jsbarcode-format="CODE128"
                            jsbarcode-value={binId}
                            jsbarcode-margin="0"
                            jsbarcode-margintop="5"
                            jsbarcode-marginbottom="0"
                            jsbarcode-marginleft="5"
                            jsbarcode-fontoptions="bold"
                        ></svg>
                    </div>
                </div>
                <div className="label-column -span7 txt-right">
                    <h3>{destination}</h3>
                    <p>
                        Received: <b>{format(new Date(received), DATE_FNS_SHORT_DATE_FORMAT)}</b>
                    </p>
                    <p>
                        Final Due: <b>{format(new Date(due), DATE_FNS_SHORT_DATE_FORMAT)}</b>
                    </p>
                    {isPerishable && <h3 className="-uppercase">Perishable</h3>}
                </div>
            </div>
            <div>
                <p className="tracking">Tracking #: {trackingNumbers.join(", ")}</p>
                <p>
                    Client: <b>{client}</b>
                </p>
                <p>
                    Supplier: <b>{supplier}</b>
                </p>
                <br />
            </div>
            <div className="label-row">
                <div className="label-column -span4">
                    <div className="date-group">
                        <p>
                            {measureingDue.tags[0]}
                            <br />
                            <b>{format(new Date(measureingDue.due), DATE_FNS_SHORT_DATE_FORMAT)}</b>
                        </p>
                        <div className="sign-icon"></div>
                    </div>
                </div>
                <div className="label-column -span8">
                    <div className="date-group -photo">
                        <p>
                            {photoDue.tags[0]}
                            <br />
                            <b>{format(new Date(photoDue.due), DATE_FNS_SHORT_DATE_FORMAT)}</b>
                        </p>
                        <div className="sign-icon"></div>
                    </div>
                </div>
            </div>
            <div className="label-row">
                <div className="label-column -span6">
                    {index} of {total}
                </div>
                <div className="label-column -span6 txt-right">
                    <p>
                        UPC count: <span className="upc-count">{upcCount}</span>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default BinLabel;
